import { render, staticRenderFns } from "./InputControl.vue?vue&type=template&id=5c5a30e8&"
import script from "./InputControl.vue?vue&type=script&lang=js&"
export * from "./InputControl.vue?vue&type=script&lang=js&"
import style0 from "./InputControl.vue?vue&type=style&index=0&id=5c5a30e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports